<ng-template #SelectExportUserInforModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Chọn các trường cần export</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-6" *ngFor="let field of exportFields">
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" [id]="field.key" [checked]="field.selected"
            (change)="toggleField(field.key)" />
          <label class="form-check-label" [for]="field.key">
            {{ field.label }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="left-part"></div>
    <div class="right-part">
      <button class="btn btn-primary" (click)="export()">Export</button>
    </div>
  </div>
</ng-template>